import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppFileItemQueryCriteriaClass extends BaseCriteriaModel {
  file_name?: Optional<string> = Optional.empty();
  file_type?: Optional<string> = Optional.empty();

}

export class AppFileItemCriteriaModelQuery {
  query = '';

  constructor(appFileItemCriteriaModel: AppFileItemQueryCriteriaClass) {

    if (!appFileItemCriteriaModel) {
      return;
    }

    this.query += appFileItemCriteriaModel.file_name.filter(x => x !== '').map(x => '&file_name=' + x).orElse('');
    this.query += appFileItemCriteriaModel.file_type.filter(x => x !== '').map(x => '&file_type=' + x).orElse('');

    this.query += '&status=' + appFileItemCriteriaModel.status;
    this.query += '&orderBy=' + appFileItemCriteriaModel.orderBy;
    this.query += '&order=' + appFileItemCriteriaModel.order;
    this.query += '&offset=' + appFileItemCriteriaModel.offset + '&limit=' + appFileItemCriteriaModel.limit;
  }
}
